export default num => !Number.isNaN(parseInt(num)) && isFinite(num);
